import React from 'react'
import MetaTags from 'react-meta-tags'
import {withNav} from '../../core/components/navbar/index'
import {UniLink} from '../../core/components/unilink/index'
import oops from '../../core/img/oops.svg'
import './notFound.css'

class NotFound extends React.PureComponent {
  render() {
    const { history } = this.props
    return (
      <div className='not_found component'>
        <MetaTags>
          <title>Not Found - Expii</title>
          <meta name="og:title" content="Not Found - Expii" />
          <meta name="description" content="404 Error. The page you are looking for doesn't exist." />
          <meta name="og:description" content="404 Error. The page you are looking for doesn't exist." />
        </MetaTags>
        <div className='not_found__white' >
          <div className='not_found__text'>
            <img src={oops} className='not_found__img' alt='Oops' />
            <h1>404 ERROR</h1>
            <span>
              The page you are looking for doesn’t exist or another error occured. <UniLink onClick={history.goBack}>Go back</UniLink> or go to 
              our <UniLink to='/'>home page</UniLink> to choose a new direction.
            </span>
          </div>
        </div>
        <div className='not_found__gray' />
      </div>
    )
  }
}

export default withNav(NotFound)



// WEBPACK FOOTER //
// ./src/domains/error/404.js